import MUICloseIcon from '@mui/icons-material/Close'

export const CloseIcon = MUICloseIcon
